"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toC = void 0;

var _godfather = require("./godfather");

var toC = function toC(f) {
  var events = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ['onClick'];
  var opts = arguments.length > 2 ? arguments[2] : undefined;
  return function (props) {
    return (0, _godfather.Godfather)(f, props, events, opts);
  };
};

exports.toC = toC;